import { Box } from '@material-ui/core';
import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { ProcessingStrategyButton } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/ProcessingStrategyButton';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { CustomSkeleton } from '@/components/shared/components/CustomSkeleton';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useScreen } from '@/hooks/useScreen';

interface ConditionsProps {
  paymentMethodDetailEntity: CardOnboardingPaymentMethodDetailEntity;
}

export const Conditions = ({ paymentMethodDetailEntity }: ConditionsProps) => {
  const { sm } = useScreen();
  const { getTextIdTranslation } = useTranslation();

  const operativeType = paymentMethodDetailEntity.operativeType;

  const subtitle = operativeType ? `${getTextIdTranslation(operativeType)}` : '';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gridGap: sm ? 12 : 8,
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: sm ? 'row' : 'column-reverse',
          justifyContent: sm ? 'space-between' : 'flex-start',
          alignItems: 'flex-start',
          gridGap: sm ? 16 : 8,
          width: '100%',
        }}
      >
        <FlexColumn>
          <Font variant="h2" color="title" style={{ wordBreak: 'break-all' }}>
            {getTextIdTranslation(PaymentMethodType.CREDIT_CARD)}
          </Font>
          <Font variant="subtitle1" color="title" style={{ wordBreak: 'break-all' }}>
            ({subtitle})
          </Font>
        </FlexColumn>

        {paymentMethodDetailEntity.paymentMethod ? (
          <ProcessingStrategyButton paymentMethodDetailEntity={paymentMethodDetailEntity} />
        ) : (
          <Box minWidth={80}>
            <CustomSkeleton height={24} />
          </Box>
        )}
      </div>
    </div>
  );
};
